import { postAntenatal, myAntenatal } from '@/services/antenatal.service';

export default {
	namespaced: true,
	state: {
		// STATUS
		antenatal: [],
		antenatalStatus: 'init',
	},
	getters: {
		// STATUS
		getAntenatalStatus(state) {
			return state.antenatalStatus
		},
		getAllAntenatal(state){
			return state.antenatal
		},
	},
	mutations: {
		// STATUS
		ANTENATAL_STATUS(state, value) {
			state.antenatalStatus = value;
		},
		SET_ANTENATAL(state, value) {
			state.antenatal = value;
		},
	},
	actions: {
		async sendAntenatal({ commit }, params) {
			commit('ANTENATAL_STATUS', 'pending');
			try {
				const { data } = await postAntenatal(params)
				commit('ANTENATAL_STATUS', 'init');
				return data;
			} catch (error) {
				commit('ANTENATAL_STATUS', 'init');
				throw error
			}
		},
		async getAntenatal({ commit }, params) {
			commit('ANTENATAL_STATUS', 'pending');
			try {
				const { data } = await myAntenatal(params)
				commit('ANTENATAL_STATUS', 'init');
				commit('SET_ANTENATAL', data.items);
				return data;
			} catch (error) {
				commit('ANTENATAL_STATUS', 'init');
				commit('SET_ANTENATAL', error.response.data);
				throw error
			}
		},
	}
}
